import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CriticalSeverityColors, ModerateSeverityColors } from '@twaice-fe/frontend/shared/utilities';
import { StorageLevel } from '@twaice-fe/shared/models';
import { ChartInfoItemContent, ChartMissingDataContent } from './models/chart-info.models';

function addLabelToUnits(units: string[]): { label: string; value: string }[] {
  return units.map((unit) => ({ label: `in ${unit}`, value: unit }));
}

@Component({
  selector: 'twaice-fe-chart-info',
  templateUrl: './chart-info.component.html',
  styleUrls: ['./chart-info.component.scss'],
  standalone: false,
})
export class ChartInfoComponent implements OnChanges {
  @Input() chartTitle: string;
  @Input() chartMissingDataContent: ChartMissingDataContent;
  @Input() chartItemList: ChartInfoItemContent[];
  @Input({ transform: addLabelToUnits }) unitOptions: { label: string; value: string }[];
  @Input() selectedUnit: string;
  @Output() itemClick: EventEmitter<ChartInfoItemContent> = new EventEmitter<ChartInfoItemContent>();
  @Output() filterMissingData: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() selectUnit: EventEmitter<string> = new EventEmitter<string>();

  percent: number;
  previousSelectedUnit: string | undefined = undefined;

  protected readonly storageLevel = StorageLevel;
  protected readonly criticalSeverityColors = CriticalSeverityColors;
  protected readonly moderateSeverityColors = ModerateSeverityColors;

  constructor() {}

  onSegmentedChange(newValue: string) {
    // ignore initial event that is triggered by setting the nz segmented options
    if (this.previousSelectedUnit !== undefined) {
      this.selectUnit.emit(newValue);
    }
    this.previousSelectedUnit = newValue;
  }

  ngOnChanges() {
    this.percent = null;

    if (this.chartMissingDataContent?.dataCount && this.chartMissingDataContent?.missingDataCount != null) {
      this.percent = (this.chartMissingDataContent.missingDataCount / this.chartMissingDataContent.dataCount) * 100;
    }
  }
}
